import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import Drivers from "./pages/Drivers";
import LiveUsers from "./pages/LiveUsers";
import Agreements from "./pages/Agreements";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Services from "./pages/Services";
import Orders from "./pages/Orders";
import Coupons from "./pages/Coupons";
import Settings from "./pages/Settings";
import Spots from "./pages/Spots";
import RoadBlocks from "./pages/RoadBlocks";
import Blogs from "./pages/Blogs";
import TimeSlots from "./pages/TimeSlots";
import Login from "./pages/Login";
import RecoverPassword from "./pages/RecoverPassword";
import { ToastProvider } from "./components/Toast";

function App() {
  const token = useSelector((state) => state.auth.token);

  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          {/* Auth routes — redirect to dashboard if already logged in */}
          <Route
            path="/login"
            element={token ? <Navigate to="/" replace /> : <Login />}
          />
          <Route
            path="/recover-password"
            element={token ? <Navigate to="/" replace /> : <RecoverPassword />}
          />

          {/* Protected admin routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="drivers" element={<Drivers />} />
              <Route path="live-users" element={<LiveUsers />} />
              <Route path="agreements" element={<Agreements />} />
              <Route path="users" element={<Users />} />
              <Route path="services" element={<Services />} />
              <Route path="orders" element={<Orders />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="settings" element={<Settings />} />
              <Route path="spots" element={<Spots />} />
              <Route path="road-blocks" element={<RoadBlocks />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="time-slots" element={<TimeSlots />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route
            path="*"
            element={<Navigate to={token ? "/" : "/login"} replace />}
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
